import { Input, Tooltip } from "antd";
import { useState, useEffect } from "react";

interface ExtraChargeProps {
  extraCharges: {
    waitingCharge: string;
    ambulanceCharge: string;
    oxygenCharge: string;
    others: string;
    helper: number;
    wheelchair: boolean;
    stretcher: boolean;
    paramedic: boolean;
    doctorOnBoard: boolean;
  };
  setExtraCharges: (charges: any) => void;
  dropLocations: any[];
  setDropLocations: (locations: any[]) => void;
  onSelectDropLocation: (index: number) => void;
  onDeleteDropLocation: (index: number) => void;
  onSave: () => void;
  isSaving: boolean;
  onSendPaymentLink: (totalAmount: number) => void;
  distanceData?: any[];
  ticketId?: string;
  fareData?: any;
  hasUnsavedChanges?: boolean;
}

export const ExtraCharge: React.FC<ExtraChargeProps> = ({ extraCharges, setExtraCharges, dropLocations, setDropLocations, onSelectDropLocation, onDeleteDropLocation, onSave, isSaving, onSendPaymentLink, distanceData = [], ticketId, fareData: propFareData, hasUnsavedChanges = false }) => {
  const [fareData, setFareData] = useState<any>(null);
  
  useEffect(() => {
    if (propFareData) {
      setFareData(propFareData);
    }
  }, [propFareData]);
  
  const calculateTotalDistance = () => {
    if (!distanceData || distanceData.length === 0) return { distance: '0 km', duration: '0 mins' };
    
    let totalKm = 0;
    let totalMins = 0;
    
    distanceData.forEach(data => {
      const distanceMatch = data.distance.match(/([\d.]+)\s*km/);
      if (distanceMatch) totalKm += parseFloat(distanceMatch[1]);
      
      const durationMatch = data.duration.match(/([\d.]+)\s*min/);
      if (durationMatch) totalMins += parseFloat(durationMatch[1]);
    });
    
    return { distance: `${totalKm.toFixed(1)} km`, duration: `${totalMins} mins` };
  };
  
  const totalStats = calculateTotalDistance();
  
  return (
    <>
      {/* <div style={{ padding: "1rem 0", borderBottom: "1px solid #e8e8e8", marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.75rem", fontWeight: 600, fontSize: "16px", color: "#333" }}>Type of Assistance Required</label>
        <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={extraCharges.wheelchair}
              onChange={(e) => setExtraCharges({ ...extraCharges, wheelchair: e.target.checked })}
              style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#00A7B5" }}
            />
            <span style={{ fontWeight: 500 }}>Wheelchair</span>
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={extraCharges.stretcher}
              onChange={(e) => setExtraCharges({ ...extraCharges, stretcher: e.target.checked })}
              style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#00A7B5" }}
            />
            <span style={{ fontWeight: 500 }}>Stretcher</span>
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={extraCharges.paramedic}
              onChange={(e) => setExtraCharges({ ...extraCharges, paramedic: e.target.checked })}
              style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#00A7B5" }}
            />
            <span style={{ fontWeight: 500 }}>Paramedic</span>
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={extraCharges.doctorOnBoard}
              onChange={(e) => setExtraCharges({ ...extraCharges, doctorOnBoard: e.target.checked })}
              style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#00A7B5" }}
            />
            <span style={{ fontWeight: 500 }}>Doctor On Board</span>
          </label>
        </div>
      </div> */}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1rem", padding: "1rem 0" }}>
        <div>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Waiting Charge</label>
          <Input
            type="text"
            placeholder="Enter waiting charge"
            value={extraCharges.waitingCharge}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
              setExtraCharges({ ...extraCharges, waitingCharge: value });
            }}
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Ambulance Charge</label>
          <Input
            type="text"
            placeholder="Enter ambulance charge"
            value={extraCharges.ambulanceCharge}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
              setExtraCharges({ ...extraCharges, ambulanceCharge: value });
            }}
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Oxygen Charge</label>
          <Input
            type="text"
            placeholder="Enter oxygen charge"
            value={extraCharges.oxygenCharge}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
              setExtraCharges({ ...extraCharges, oxygenCharge: value });
            }}
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Others</label>
          <Input
            type="text"
            placeholder="Enter other charges"
            value={extraCharges.others}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
              setExtraCharges({ ...extraCharges, others: value });
            }}
            style={{ width: "100%" }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Helper</label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <button
              onClick={() => setExtraCharges({ ...extraCharges, helper: Math.max(0, extraCharges.helper - 1) })}
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#00A7B5",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              -
            </button>
            <span style={{ fontSize: "16px", fontWeight: 500, minWidth: "30px", textAlign: "center" }}>
              {extraCharges.helper}
            </span>
            <button
              onClick={() => setExtraCharges({ ...extraCharges, helper: extraCharges.helper + 1 })}
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#00A7B5",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "2rem", borderTop: "2px solid #e8e8e8", paddingTop: "1.5rem" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem", flexWrap: "wrap", gap: "1rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <label style={{ fontWeight: 600, fontSize: "18px", color: "#333" }}>Drop Locations</label>
            {distanceData.length > 0 && (
              <div style={{ backgroundColor: "#e0f7f9", padding: "0.4rem 1rem", borderRadius: "20px", fontSize: "13px", color: "#00A7B5", fontWeight: 600, border: "1px solid #00A7B5" }}>
                📍 Total: {totalStats.distance} • ⏱️ {totalStats.duration}
              </div>
            )}
          </div>
          <button
            onClick={() => {
              setDropLocations([...dropLocations, null]);
            }}
            style={{
              padding: "0.6rem 1.2rem",
              backgroundColor: "#00A7B5",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600,
              boxShadow: "0 2px 4px rgba(0, 167, 181, 0.2)",
              transition: "all 0.2s"
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#008c99"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#00A7B5"}
          >
            + Add Drop Location
          </button>
        </div>
        {dropLocations.filter((_, index) => !(index === 0 && dropLocations.length === 1)).length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: "0", backgroundColor: "#fafafa", padding: "1rem", borderRadius: "8px" }}>
            {dropLocations.map((location, index) => {
              const isFirstDrop = index === 0;
              if (isFirstDrop && dropLocations.length === 1) return null;
              return (
                <div key={index}>
                  <div style={{ display: "flex", gap: "0.75rem", alignItems: "flex-start", padding: "1rem", border: "2px solid", borderColor: isFirstDrop ? "#00A7B5" : "#e0e0e0", borderRadius: "8px", backgroundColor: "white", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
                        <div style={{ width: "28px", height: "28px", borderRadius: "50%", backgroundColor: isFirstDrop ? "#00A7B5" : "#666", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: 600 }}>{index + 1}</div>
                        {isFirstDrop && (
                          <span style={{
                            padding: "0.25rem 0.6rem",
                            backgroundColor: "#00A7B5",
                            color: "white",
                            borderRadius: "12px",
                            fontSize: "11px",
                            fontWeight: 600,
                            letterSpacing: "0.3px"
                          }}>
                            PICKUP LOCATION
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: "15px", color: "#222", fontWeight: 600, marginBottom: "0.25rem" }}>{location?.name || location?.hospitalName || "No hospital selected"}</div>
                      <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.4" }}>{location?.address || "No address"}</div>
                    </div>
                    {!isFirstDrop && (
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <button
                          onClick={() => onSelectDropLocation(index)}
                          style={{
                            padding: "0.4rem 1rem",
                            backgroundColor: "#00A7B5",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: 600,
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                          }}
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => onDeleteDropLocation(index)}
                          style={{
                            padding: "0.4rem 0.6rem",
                            backgroundColor: "#ff4d4f",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: 600,
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </div>
                  {index < dropLocations.length - 1 && distanceData[index] && (
                    <div style={{ display: "flex", alignItems: "center", padding: "0.75rem 0", marginLeft: "2rem" }}>
                      <div style={{ position: "relative", width: "3px", height: "50px", background: "linear-gradient(180deg, #00A7B5 0%, #008c99 100%)", marginRight: "1.5rem", borderRadius: "2px" }}>
                        <div style={{ position: "absolute", bottom: "-5px", left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: "10px solid #008c99" }}></div>
                      </div>
                      <div style={{ backgroundColor: "white", padding: "0.5rem 1rem", borderRadius: "20px", fontSize: "13px", color: "#00A7B5", fontWeight: 600, boxShadow: "0 2px 6px rgba(0,167,181,0.15)", border: "1px solid #e0f7f9" }}>
                        📍 {distanceData[index].distance} • ⏱️ {distanceData[index].duration}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ marginTop: "1.5rem", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem", flexWrap: "wrap" }}>
        <Tooltip
          title={
            fareData?.breakdown ? (
              <div>
                {Object.entries(fareData.breakdown).map(([key, value]: [string, any]) => (
                  <div key={key} style={{ display: "flex", justifyContent: "space-between", gap: "1.5rem", padding: "0.15rem 0" }}>
                    <span>{key.replace(/([A-Z])/g, ' $1').trim()}:</span>
                    <span style={{ fontWeight: 500 }}>₹{value}</span>
                  </div>
                ))}
              </div>
            ) : null
          }
          placement="topRight"
        >
          <div style={{ padding: "0.5rem 1rem", backgroundColor: "#e0f7f9", borderRadius: "4px", border: "1px solid #00A7B5", cursor: "pointer" }}>
            <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
              <span style={{ fontWeight: 500, fontSize: "14px", color: "#666" }}>Total Fare:</span>
              <span style={{ fontWeight: 700, fontSize: "16px", color: "#00A7B5" }}>₹{fareData?.totalFare || 0}</span>
            </div>
          </div>
        </Tooltip>
        <button
          onClick={onSave}
          disabled={isSaving}
          style={{
            padding: "0.75rem 2rem",
            backgroundColor: isSaving ? "#ccc" : "#00A7B5",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: isSaving ? "not-allowed" : "pointer",
            fontSize: "16px",
            fontWeight: 600
          }}
        >
          {isSaving ? "Saving..." : "Save"}
        </button>
        <button
          onClick={() => onSendPaymentLink(fareData?.totalFare || 0)}
          disabled={hasUnsavedChanges}
          style={{
            padding: "0.75rem 2rem",
            backgroundColor: hasUnsavedChanges ? "#ccc" : "#061DB2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: hasUnsavedChanges ? "not-allowed" : "pointer",
            fontSize: "16px",
            fontWeight: 600
          }}
        >
          Send Payment Link
        </button>
      </div>
    </>
  );
};
